
export default {
  name: 'AccountConfirmedPage',
  data() {
    return {
      config: {
        provider: 'spendgo',
        placement: 'account',
        forgot_placement: '',
        forgot_text: '',
        confirmed_text: 'Sign In',
        submit_icon: true,
        component_animation: '',
        background_animation: 'animate__animated animate__fadeInLeft',
        form_animation: 'animate__animated animate__fadeInRight',
        confirmed_header: {
          title: 'Almost there',
          navLinks: [],
          helper: "Once you've confirmed your email address, you'll be the newest member of the Lee's Famous Rewards.",
          icon: {
            name: 'profile-icon',
            classes: '',
          },
        }
      }
    }
  },
  head() {
    return this.$utils.head(this.story)
  },
  async asyncData({ $utils }) {
    const confirmed = await $utils.content('account/confirmed')
    if (!confirmed) {
      return {
        story: null,
        confirmedStoryblok: undefined,
      }
    }

    const sections = confirmed.content.sections || []
    const sectionFound = sections.find(section => section.component === 'sign-in-up-forgot-confirmed')
    const signInUpPassword = sectionFound ? sectionFound : null

    const appSectionFound = sections.find(section => section.component === 'download-app')
    const dowloadApp = appSectionFound ? appSectionFound : null

    return {
      story: confirmed,
      confirmedStoryblok: {
        ...signInUpPassword,
        ...dowloadApp,
      },
    }
  },
}
